var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"size"},[_c('h6',[_vm._v(" "+_vm._s(_vm.item.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }